<template>
  <div class="nav-menu">
    <div class="logo_mobile">
      <div class="logo-glow"></div>
      <img src="/imgs/logo.png" alt="logo" @click="$router.replace({ name: 'index' })" />
    </div>
    <LmobileMenu />
  </div>
</template>

<script>
import LmobileMenu from '@/components/Lnav/LmobileMenu/index.vue'
export default {
  name: 'control',
  components: {
    LmobileMenu
  }
}
</script>

<style lang="scss" scoped>
.nav-menu {
  min-height: 100vh;
  background: linear-gradient(160deg, #f5f7fb 0%, #eef1f8 30%, #f8f9fc 60%, #f0f3fa 100%);
  .logo_mobile {
    position: relative;
    font-size: 0;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(48, 103, 242, 0.08);
    box-shadow: 0 1px 20px rgba(48, 103, 242, 0.04);
    overflow: hidden;
    .logo-glow {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 140px;
      height: 60px;
      background: radial-gradient(ellipse, rgba(48, 103, 242, 0.06) 0%, transparent 70%);
      pointer-events: none;
    }
    img {
      width: 121px;
      position: relative;
      z-index: 1;
      transition: transform 0.3s ease, filter 0.3s ease;
      &:hover {
        transform: scale(1.04);
        filter: brightness(1.08);
      }
    }
  }
}
</style>
